<template>
  <div>
    <div class="unverified">
      <img v-lazy="require('@/assets/img/userInfo/wrz.png')" alt />
      <!-- <img src="@/assets/img/userInfo/未认证提醒.png" alt /> -->
      <div>您还没有认证哦，请及时认证获得更多权限</div>
    </div>
    <div class="status">
      <div class="statusList">
        <img v-lazy="require('@/assets/img/userInfo/xzrz.png')" alt />
        <div class="name">学者认证</div>
        <div class="jdt">认证后您将获得以下权限</div>
        <div class="blue">开通百家号</div>
        <div class="blue">个人文献库</div>
        <div class="blue">资讯内容发布</div>
        <div class="blue">百家在线学者空间</div>
        <div @click="to" style="cursor: pointer" class="good">立即认证</div>
      </div>
      <div class="statusList">
        <img v-lazy="require('@/assets/img/userInfo/qkrz.png')" alt />
        <div class="name">期刊认证</div>
        <div class="jdt">认证后您将获得以下权限</div>
        <div class="blue">开通百科号</div>
        <div class="blue">期刊文献库</div>
        <div class="blue">资讯内容发布</div>
        <div class="blue">征稿函发布</div>
        <div class="blue">百家在线期刊空间</div>
        <div class="blue">投审稿业务</div>
        <div @click="go" style="cursor: pointer" class="good">立即认证</div>
      </div>
      <div class="statusList">
        <img v-lazy="require('@/assets/img/userInfo/jgrz.png')" alt />
        <div class="name">机构认证</div>
        <div class="jdt">认证后您将获得以下权限</div>
        <div class="blue">开通机构号</div>
        <div class="blue">机构文献库</div>
        <div class="blue">资讯内容发布</div>
        <div class="blue">文摘发布</div>
        <div class="blue">报告发布</div>
        <div class="bad" style="cursor: pointer">暂未开通</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "center",
  data() {
    return {};
  },
  methods: {
    go() {
      this.$router.push("/user/periodicalRz");
    },
    to() {
      this.$router.push("/user/scholarRz");
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  .unverified {
    width: 1200px;
    height: 232px;
    background: #ffffff;
    box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    img {
      width: 215px;
      height: 180px;
      // border-radius:50%;
      // background:red;
    }

    div {
      width: 1200px;
      text-align: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #02157e;
    }
  }

  .status {
    margin-top: 20px;

    width: 1200px;
    height: 962px;
    display: flex;
    justify-content: space-between;

    .statusList {
      width: 33%;
      height: 962px;
      background: #ffffff;
      box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: flex-start;
      position: relative;

      .jdt {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-align: center;
        color: #2c2c2c;
        width: 484px;
        margin-top: 66px;
      }

      .name {
        margin-top: 47px;
        width: 484px;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: #2a2a2a;
        line-height: 24px;
      }

      .good {
        width: 208px;
        height: 63px;
        background: #02157e;
        text-align: center;
        line-height: 63px;
        border-radius: 30px;
        color: white;
        position: absolute;
        bottom: 61px;

        a {
          color: white;
        }
      }

      .bad {
        text-align: center;
        line-height: 63px;
        width: 208px;
        height: 63px;
        background: #d2d2d2;
        border-radius: 30px;
        position: absolute;
        bottom: 61px;
      }

      .blue {
        margin-top: 27px;
        text-align: center;
        font-size: 18px;
        width: 484px;
        font-weight: 400;
        color: #06167c;
      }

      img {
        width: 265px;
        height: 227px;
        margin-top: 70px;
      }
    }
  }
}
</style>
